import { NgModule } from '@angular/core';
import { LoaderComponent } from '@shared/components/loader/loader.component';

@NgModule({
  declarations: [LoaderComponent],
  exports: [LoaderComponent]
})
export class LoaderModule {}
